import {
  Heading4,
  TextBodyBold,
} from '@front/components/data-display/typography/Typography'
import { AppButton } from '@front/components/inputs/app-button'
import { VanillaButtonStyle } from '@front/shared/constants/styles/VanillaButtonStyle'
import { PlaceOutlined } from '@mui/icons-material'
import { Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

type CardProps = {
  name: string
  address?: string
  apply: () => void
}

export default function ApplyCard({ name, address, apply }: CardProps) {
  const theme = useTheme()
  const { t } = useTranslation('main.worker')

  const mapsAddress = (address ?? '').replaceAll(' ', '+')
  const mapsAddressUrl = `https://www.google.fr/maps/place/${mapsAddress}`

  const goToMaps = () => {
    window.open(mapsAddressUrl, '_blank', 'noopener, noreferrer')
  }

  return (
    <Stack
      sx={{
        borderRadius: 4,
        boxShadow:
          '0 2px 4px 0 rgba(25, 23, 21, 0.03), 0 8px 8px 0 rgba(25, 23, 21, 0.02)',
        border: '1px solid',
        borderColor: theme.palette.border['brand-subtle'],
        backgroundColor: theme.palette.background.surface,
      }}
    >
      <Stack sx={{ width: '380px', padding: 2, gap: 2 }}>
        <Heading4>{name}</Heading4>
        <button style={VanillaButtonStyle} onClick={() => goToMaps()}>
          <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
            <PlaceOutlined
              fontSize="small"
              sx={{
                color: theme.palette.text.primary,
              }}
            />
            <TextBodyBold
              sx={{
                color: theme.palette.text.brand,
                textDecoration: 'underline',
                textAlign: 'start',
              }}
            >
              {address}
            </TextBodyBold>
          </Stack>
        </button>
        <AppButton onClick={apply} size="small">
          {t('shift_details.button_apply')}
        </AppButton>
      </Stack>
    </Stack>
  )
}
